<template>
    <el-container class="index-con">
      <div class="index-header" style="border-bottom: solid 1px #e6e6e6;">
        <navcon></navcon>
      </div>
      <div class="index-page"></div>
      <div style="background-color: #f8f9fb;">
      <div class="main-con">
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>服务与支持</el-breadcrumb-item>
            <el-breadcrumb-item>{{ id==1?'常见问题':(id==2?'新手指南':'用户手册') }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="aside-main">
            <el-aside style="width: 240px;">
                <supportLeft @forward="forward" :id="id"></supportLeft>
            </el-aside>
            <el-main class="index-main">
                <course v-if="id==1"></course>
                <guide v-else-if="id==2" @change="change"></guide>
                <manual v-else-if="id==3"></manual>
                <detail v-else-if="name" :params="params" :name="name"></detail>
            </el-main>
        </div>
      </div>
    </div>
      
  
      <el-footer class="index-footer" style="height: auto; background-color: #f0f4f7;border-top: solid 1px #e6e6e6">
        <footers></footers>
      </el-footer>
    </el-container>
  </template>
  <script>
  // 导入组件
  import navcon from '../../components/navcon.vue'
  import footers from '../../components/footers.vue'
  import supportLeft from '../../components/supportLeft.vue'
  import course from '../../views/support/course.vue'
  import guide from '../../views/support/guide.vue'
  import manual from '../../views/support/manual.vue'
  import detail from '../../views/support/details.vue'
//   import { bannerList } from '../../api/userMG'
  export default {
    name: 'support',
    data() {
      return {
        id:1,
        name:'常见问题',
        params:{},
      }
    },
    // 注册组件
    components: {
      navcon,
      footers,
      supportLeft,
      course,
      guide,
      manual,
      detail
    },
    computed: {
      url() {
        return this.$store.getters.url;
      }
    },
    created() {
    //   this.getHome();
      this.id = this.$route.query.id;
    },
   
    methods:{
        forward(id,name){
            console.log(id,name)
            this.id = id;
            this.name = name;
        },
        change(item){
          console.log("iitem",item)
          this.id = item.id;
          this.params = item;
          this.name = item.name
        }
     
    }
  }
  </script>
  
  <style scoped>
    
    @media (min-width: 1366px) {
    .main-con { 
        width: 1000px;
      }
    }
  @media (min-width: 1600px) {
    .main-con {
      width: 1300px;
    }
  }
  .aside-main{
    display: flex;
  }
  .index-main{
    padding: 10px 20px;
  }
  .main-con {
    margin: auto;
    padding-bottom: 40px;
  }
  .index-con {
    height: 100%;
    box-sizing: border-box;
    margin: auto;
  }
  .breadcrumb{
    padding: 30px 0;
  }
  /* .breadcrumb span{
    font-size: 12px;
  } */
   
   
  </style>
  


// WEBPACK FOOTER //
// src/views/index/support.vue